import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    data: _ctx.detail,
    border: "",
    fit: "",
    "row-key": "materialId",
    "header-cell-style": { background: '#ddd', color: 'rgba(0,0,0,0.9)' },
    "span-method": _ctx.objectSpanMethod,
    "summary-method": _ctx.mode === 'storage' ? undefined : _ctx.getSummaries,
    "show-summary": _ctx.mode !== 'storage'
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "prev"),
      _createVNode(_component_el_table_column, {
        prop: "fee",
        label: "单价",
        fixed: "",
        "min-width": "100"
      }),
      _createVNode(_component_el_table_column, {
        prop: "amount",
        label: "数量",
        fixed: "",
        "min-width": "100"
      }),
      (_ctx.storageVisible)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_el_table_column, {
              prop: "inputStorageNum",
              label: "已入库数量",
              "min-width": "100"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", null, _toDisplayString(row.inputStorageNum || 0), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "remainAmount",
              label: "剩余数量",
              "min-width": "100"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", null, _toDisplayString(row.remainAmount || 0), 1)
              ]),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_component_el_table_column, {
        prop: "materialNo",
        label: "物料编号",
        "min-width": "160"
      }, {
        default: _withCtx(({ row }) => [
          _createElementVNode("span", null, _toDisplayString(row.materialNo || row.no), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        prop: "materialName",
        label: "物料名称",
        "min-width": "120",
        "show-overflow-tooltip": ""
      }, {
        default: _withCtx(({ row }) => [
          _createElementVNode("span", null, _toDisplayString(row.materialName || row.name), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        prop: "materialBrand",
        label: "物料品牌",
        "min-width": "100",
        "show-overflow-tooltip": ""
      }, {
        default: _withCtx(({ row }) => [
          _createElementVNode("span", null, _toDisplayString(row.materialBrand || row.brand), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        prop: "materialModel",
        label: "物料型号",
        "min-width": "120",
        "show-overflow-tooltip": ""
      }, {
        default: _withCtx(({ row }) => [
          _createElementVNode("span", null, _toDisplayString(row.materialModel || row.model), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        prop: "materialUnit",
        label: "物料单位",
        "min-width": "100",
        "show-overflow-tooltip": ""
      }, {
        default: _withCtx(({ row }) => [
          _createElementVNode("span", null, _toDisplayString(row.materialUnit || row.unit), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        prop: "materialStandard",
        label: "封装规格",
        "min-width": "120",
        "show-overflow-tooltip": ""
      }, {
        default: _withCtx(({ row }) => [
          _createElementVNode("span", null, _toDisplayString(row.materialStandard || row.standard), 1)
        ]),
        _: 1
      }),
      (_ctx.mode === 'purchase')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_el_table_column, {
              prop: "materialCreateUser",
              label: "申请人",
              "min-width": "110",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "materialAmount",
              label: "申请数量",
              "min-width": "120"
            })
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.mode === 'storage')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode(_component_el_table_column, {
              prop: "materialLocation",
              label: "入库位置",
              "min-width": "160",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "locationAmount",
              label: "入库数量",
              "min-width": "120"
            }),
            _createVNode(_component_el_table_column, {
              prop: "locationDate",
              label: "入库时间",
              "min-width": "200",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "locationUser",
              label: "入库人",
              "min-width": "120"
            })
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_component_el_table_column, {
        prop: "total",
        label: "合计",
        fixed: "right",
        "min-width": "100"
      }, {
        default: _withCtx(({ row }) => [
          _createElementVNode("span", null, _toDisplayString(_ctx.handleRoundNum(row.fee * row.amount)), 1)
        ]),
        _: 1
      }),
      _renderSlot(_ctx.$slots, "after")
    ]),
    _: 3
  }, 8, ["data", "span-method", "summary-method", "show-summary"]))
}